export default {
  header: {
    title: 'Fedt! Du får følgende gratis med din ordre:',
    subtitle: 'Vi trækker rabatten fra under betalingen.',
  },
  footer: {
    buttons: {
      no_thanks: 'Nej tak',
      add_to_basket: 'Læg i kurv',
    },
  },
};
